import React  from 'react';
import styled from 'styled-components';

const RequiredSpan = styled.span`
  font-weight  : bold;
  margin-right : 4px;
  color        : ${({ theme: { textColor } }): string => textColor.red};
`;

export const RequiredSign = (): JSX.Element => <RequiredSpan>*</RequiredSpan>;
